export const IS_DARK = "IS_DARK";
export const setIsDark = (isDark)=>(dispatch)=>{
dispatch({
    type: IS_DARK,
    payload:isDark
})
};